import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const WatermarkValueContext = createContext<typeof initialState>(initialState);

const WatermarkActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { WatermarkActionContext, WatermarkValueContext };
